import { useMemo } from 'react';

var useSelectAll = function (_a) {
    var items = _a.items, selectedItems = _a.selectedItems;
    var showSelectAll = items.length > 1;
    var allSelected = useMemo(function () {
        return items.every(function (item) { return selectedItems.includes(item); });
    }, [items, selectedItems, showSelectAll]);
    var selectAllItem = useMemo(function () {
        if (!showSelectAll)
            return {};
        return {
            value: selectedItems.length
                ? "".concat(selectedItems.length, " of ").concat(items.length, " selected")
                : "Select All (".concat(items.length, " results)"),
            checked: allSelected,
            indeterminate: !allSelected && selectedItems.length > 0
        };
    }, [showSelectAll, selectedItems, items]);
    return { allSelected: allSelected, selectAllItem: selectAllItem, showSelectAll: showSelectAll };
};

export { useSelectAll };
//# sourceMappingURL=useSelectAll.esm.js.map
